import Reflux from 'reflux';

export default Reflux.createActions({
    "alert": {sync:true},
    "createdResource": {sync:true},
    "updatedResource": {sync:true},
    "startLoading": {},
    "stopLoading": {},
    "configureAppBar": {},
    "resize": {}
});


/** WEBPACK FOOTER **
 ** ./app-react/reflux/AlertActions.js
 **/